import { register } from "swiper/element"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssNavigation from "swiper/element/css/navigation?raw"
// @ts-expect-error typescript cannot find a type for this file.
import swiperCssPagination from "swiper/element/css/pagination?raw"
import { Navigation, Pagination } from "swiper/modules"
import StarsVideos from "./StarsVideos.js"

/**
 * @typedef {HTMLElement} SwiperContainer
 * @property {Function} initialize
 */

register()

const starsVideos = new StarsVideos()

const uninitializedSwiperContainers = () /** NodeListOf<HTMLElement> */ => {
    return document.querySelectorAll(".stars-post swiper-container:not(.swiper-initialized)")
}

function slideChangeHandler() /** void */ {
    if (starsVideos === undefined) {
        return
    }

    const swiperVideoPlayers = starsVideos.videoPlayers()

    for (const videoPlayer of swiperVideoPlayers) {
        if (!videoPlayer.player) {
            continue
        }

        const player = videoPlayer.player

        if (player.paused()) {
            continue
        }

        player.pause()
    }
}

function clickHandler(/** CustomEvent */ clickEvent) {
    const [swiper] = clickEvent.detail || []
    const triggerResponse = triggerCallToActionModalIfNotFan(swiper)

    if (triggerResponse instanceof HTMLElement) {
        if (triggerResponse !== clickEvent.target) {
            triggerResponse.click()
        }
    } else if (triggerResponse === false) {
        clickEvent.preventDefault()
        clickEvent.stopPropagation()
    }
}

function triggerCallToActionModalIfNotFan({ el: swiperElement }) /** false|HTMLElement */ {
    const postContainer = swiperElement.closest(".stars-post")

    if (!postContainer) {
        return false
    }

    if (postContainer.querySelector('data[value="unpaid"]') === null) {
        return false
    }

    const fansCtAButton = swiperElement.querySelector(".fans-cta button")

    return fansCtAButton || false
}

async function initSwiperContainer(/** SwiperContainer */ container) {
    const params = {
        modules: [Navigation, Pagination],
        injectStyles: [swiperCssNavigation, swiperCssPagination],
        navigation: {
            nextEl: container.querySelector(".swiper-button-next"),
            prevEl: container.querySelector(".swiper-button-prev"),
        },
        pagination: {
            el: container.querySelector(".swiper-pagination"),
        },
        noSwipingClass: "vjs-control-bar",
    }

    Object.assign(container, params)

    container.addEventListener("swiperslidechange", () => slideChangeHandler())
    container.addEventListener("swiperclick", (clickEvent) => clickHandler(clickEvent))

    container.initialize()
    container.classList.add("swiper-initialized")
}

export const initializeSwipers = async () => {
    const swiperContainers = uninitializedSwiperContainers()

    if (!swiperContainers.length) {
        return
    }

    for (const container of swiperContainers) {
        initSwiperContainer(container).then()
    }

    starsVideos.updateLDSVideoPlayerData()
}
